import riseImage from "../rise-of-realms.jpg";
import riseImage2 from "../rise-of-realms2.jpg";
import quilttImage from "../quiltt.png";
import quiltt2Image from "../quiltt2.png";
import makethread2Image from "../makethread2.png";
import tarot1Image from "../tarot1.png";
import tarot2Image from "../tarot2.png";
import shiftsImage from "../shifts.jpg";
import productFinderImage from "../product-finder.jpg";
import dashboardImage from "../store-dashboard.jpg";
import serviceManualImage from "../service-manual.png";
import membershipImage from "../local.png";
import localImage from "../local.png";
import lcrSummitCover from "../assets/work/lcr-summit-cover.webp";
import lcrSummitNetwork from "../assets/work/lcr-summit-network.webp";
import lcrSummitPathway from "../assets/work/lcr-summit-pathway.webp";
import tuckboxHero from "../assets/work/tuckbox-hero.webp";
import sabrinaHero from "../assets/work/sabrina-hero.webp";
import buddiesHero from "../assets/work/buddies-hero.webp";
import huileHero from "../assets/work/huile-hero.webp";
import wishingWellWoodsHero from "../assets/work/wishingwellwoods-hero.webp";
import angelsHero from "../assets/work/angels-hero.webp";
import lacat2Hero from "../assets/work/lacat2-hero.webp";

// AI & data showcases: the clearest evidence of AI-augmented delivery and
// AI-native product work.
export const aiShowcases = [
  {
    title: "LCR Summit",
    role: "Data visualisation: the English curriculum as one map",
    description:
      "An interactive data-visualisation essay that renders every statement in the English national curriculum as a single navigable network: what's taught, where it sits in the sequence, and what it bridges into. Built to answer one question: what changes when you can see everything a child is taught, and every page that teaches it?",
    tech: ["Three.js", "WebGL", "D3.js", "React", "TypeScript"],
    live: "https://lcr-summit.vercel.app",
    category: "AI & Data",
    images: { cover: lcrSummitCover, network: lcrSummitNetwork, pathway: lcrSummitPathway },
  },
  {
    title: "London Ambulance Cat 2",
    role: "Open-data research: why the queue is 31m45s, tested against reality",
    description:
      "An independent study, built only from data NHS England and the London Ambulance Service publish, modelling London's ambulance crews as a queue to explain why a Category 2 call waits 31m45s against a 25-minute target. The diagnosis holds under testing: most of the wait is a queue for a free crew, not a drive, and crew time is the lever. The model's exact predictions didn't survive out-of-sample validation, so the write-up leads with the cautious estimate and ends in a specific data request to LAS rather than overclaiming precision. Every figure is tagged Real, Modelled, Illustrative, or Judgement, and the twelve-step interactive walks through the queue, the causes, and the fix.",
    tech: ["Queueing theory", "Causal inference", "Statistical modelling", "Open data", "JavaScript"],
    live: "https://london-ambulance-cat2.vercel.app/viz/ambulance.html",
    category: "AI & Data",
    image: lacat2Hero,
  },
];

export const ventureProjects = [
  {
    title: "Quiltt Retail Analytics Platform",
    role: "Chief Technology Officer",
    description:
      "Founded and built an AI-driven sales forecasting and analytics platform. Personally developed the machine learning capabilities and designed the high-availability infrastructure.",
    achievements: [
      "ML models in Python and XGBoost for sales forecasting",
      "Scalable Kubernetes platform on AWS and DigitalOcean",
      "Automated CI/CD pipelines and testing infrastructure",
    ],
    tech: ["Python", "XGBoost", "TypeScript", "Deno", "Next.js", "AWS", "Kubernetes"],
    live: "https://quiltt-1i8d9m6sq-stead-tech.vercel.app/",
    images: { quiltt: quilttImage, quiltt2: quiltt2Image },
    period: "2022 – 2023",
  },
  {
    title: "Crisis Angels",
    role: "Founder & CPTO",
    description:
      "Applied-AI mental-health safety and crisis-support platform, UK-hosted. An adaptive wellness score over five signals, AI-generated weekly summaries, and automated trigger identification, built for safety and interpretability from day one.",
    achievements: [
      "Clinically validated Stanley-Brown safety plan and one-tap crisis activation",
      "Alerts trusted contacts by push, email, and SMS, with follow-ups at days 1, 3, 7, 14",
      "End-to-end encryption, per-metric consent, UK data residency, DTAC alignment",
      "No data sales, no advertising",
    ],
    tech: ["AI/ML", "Applied NLP", "Privacy-by-design", "UK hosting"],
    live: "https://crisis-angels.com",
    period: "2025 – Present",
    image: angelsHero,
  },
  {
    title: "Rise of Realms",
    role: "Founder, AI & Product Lead",
    description:
      "A generative-AI strategic trading card game and transmedia universe. A full generative-AI production pipeline, solo: orchestrating Claude and image-generation models end to end from narrative structure to finished card art, producing 2,000 distinct, balanced card units.",
    achievements: [
      "Repeatable, agentic content pipeline at studio scale, run solo",
      "2,000 distinct card units with consistent mechanics and lore",
      "Fair pricing: $1 flat per base card, single digital-and-physical ownership",
      "Print-on-demand in 100+ languages across a transmedia universe",
    ],
    tech: ["React", "TypeScript", "WebGL", "Three.js", "D3.js", "Clojure", "Supabase", "Tailwind CSS"],
    live: "https://www.rise-of-realms.com/",
    images: { rise: riseImage, rise2: riseImage2 },
    period: "2024 – Present",
  },
  {
    title: "Tuckbox Games",
    role: "Founder, Technology & Product Lead",
    description:
      "An independent studio building games that diagnose specific learning gaps instead of just scoring performance, on procedural, rule-based mechanics rather than fixed content.",
    achievements: [
      "Studio engine shared across products: procedural generation, rule-based personalisation",
      "Two live products built on it: Sabrina and Buddies",
    ],
    tech: ["React", "TypeScript", "Procedural generation", "Game design"],
    live: "https://tuckboxgames.com",
    period: "2025 – Present",
    image: tuckboxHero,
  },
  {
    title: "Sabrina",
    role: "Founder, Product & Engineering",
    description:
      "Spelling practice for ages 5 to 11 that finds the rule a child is stuck on. Idea to a working, adaptive engine: a few hours.",
    achievements: [
      "Adaptive engine diagnoses the specific spelling rule, not just the wrong word",
      "No pupil accounts, no adverts, no tracking",
      "Teacher view surfaces exactly where each child is stuck",
    ],
    tech: ["React", "TypeScript", "Adaptive learning"],
    live: "https://sabrina-spellings.com",
    period: "2025 – Present",
    image: sabrinaHero,
  },
  {
    title: "Buddies",
    role: "Founder, Product & Engineering",
    description:
      "A character-builder API for children's products: drop-in avatars with no names or emails ever collected. Built for teams who want a safe, ready-made identity layer for kids' apps.",
    achievements: [
      "No personal data collected, by design",
      "Integrates into an existing app, game, or site in an afternoon",
      "Rewards and progression optional, left to the host product",
    ],
    tech: ["React", "TypeScript", "API design", "Child data safety"],
    live: "https://buddies.cloud",
    period: "2025 – Present",
    image: buddiesHero,
  },
  {
    title: "Huile",
    role: "Founder, Formulation, Product & Engineering",
    description:
      "Luxury face-oil skincare brand. I formulate and produce the oils myself, a signature astaxanthin blend with cacay oil and bakuchiol, and built the digital product and commerce platform end to end on Next.js.",
    achievements: [
      "Personally formulated and produced the six-SKU oil line (£65–£70)",
      "Full storefront built and owned solo, from commerce platform to brand",
    ],
    tech: ["Formulation", "Next.js", "E-commerce", "Brand & positioning"],
    live: "https://huile-skincare.com",
    period: "2026 – Present",
    image: huileHero,
  },
  {
    title: "Wishing Well Woods",
    role: "Founder, Technology & Product Lead",
    description:
      "Handcrafted laser-cut birch-plywood goods, e-commerce. Built the Next.js store end to end: catalog, cart, and fulfilment logic, for a slow-craft, sustainably sourced brand.",
    achievements: [
      "Multi-category range: home and wall decor, planters, wind chimes, fairy-garden pieces",
      "Small-batch, sustainably sourced production model",
    ],
    tech: ["Next.js", "E-commerce"],
    live: "https://wishingwellwoods.com",
    period: "2026 – Present",
    image: wishingWellWoodsHero,
  },
  {
    title: "Unique Tarot Co",
    role: "Founder & Creator",
    description:
      "A luxury tarot brand: one-of-a-kind, hand-finished cards and artworks, with a custom manufacturing pipeline across Singles, Frames, and Custom Decks.",
    achievements: [
      "Custom manufacturing pipeline for one-of-a-kind cards",
      "Engaged direct-to-consumer following on Instagram",
    ],
    tech: ["E-commerce", "Custom manufacturing", "Brand & social"],
    social: "@uniquetarotco",
    images: { tarot1: tarot1Image, tarot2: tarot2Image },
    period: "2020 – Present",
  },
  {
    title: "Make Thread",
    role: "Freelance Technical Lead / Fractional CTO",
    description:
      "A sustainable social-fashion marketplace, part Kickstarter and part social network, built from scratch for fashion creators to crowdfund and sell sustainable designs.",
    achievements: [
      "Full-stack marketplace with social profiles and crowdfunding",
      "RESTful API supporting both marketplace and social features",
    ],
    tech: ["React", "Node.js", "MongoDB", "RESTful API"],
    live: "https://www.makethread.com",
    image: makethread2Image,
    period: "2018 – 2023",
  },
];

export const clientProjects = [
  {
    title: "NHS Validated Relationships Service",
    role: "Lead Architect & Delivery, NHS Digital",
    description:
      "National proxy-access platform letting authorised people manage healthcare on behalf of patients, built serverless and event-driven across the NHS ecosystem.",
    achievements: [
      "Serverless on AWS Lambda (30+ functions), Step Functions, and EventBridge, at 98% uptime SLA",
      "Event-driven architecture supporting 700k+ proxy role migrations",
      "FHIR R4 APIs integrating 6+ NHS national systems including PDS and GP systems",
      "OAuth 2.0, JWT, KMS encryption, full audit trails; 80%+ test coverage",
    ],
    tech: ["Python 3.13", "AWS Lambda", "DynamoDB", "API Gateway", "EventBridge", "Terraform", "FHIR R4"],
    live: "https://digital.nhs.uk/developer/api-catalogue/validated-relationship-service",
    period: "2025",
  },
  {
    title: "BBC Bitesize Primary",
    role: "Software Engineering Team Lead",
    description:
      "Re-platforming one of the UK's largest children's education services (1.7m primary pupils a week, 61% weekly reach), from discovery to working alpha.",
    achievements: [
      "Event-sourced platform (CQRS, deterministic replay) built to scale to 20bn transactions a year",
      "Reframed strategy from acquisition to retention on hard evidence",
      "Reusable design-token system over a shared, accessible (WCAG-AA) component kit",
      "In-house research programme scored NPS +19 with curriculum-aware users",
    ],
    tech: ["TypeScript", "React 19", "Node.js", "PostgreSQL", "Event sourcing/CQRS", "xAPI", "AWS"],
    period: "2026 – Present",
  },
  {
    title: "BBC Games Platform Discovery",
    role: "Lead Service Designer & Technologist",
    description:
      "A 4-week, end-to-end discovery into whether the BBC could take on the New York Times' daily-games retention habit: research, service design, and a working build, no handoffs.",
    achievements: [
      "A full games platform and 30 playable games inside the timebox, using generative AI as a build multiplier",
      "Built on BBC-native infrastructure (AWS, WebCore, BBC design system) as a credible production route",
      "~20 research sessions and stakeholder workshops drove the commissioning decision on evidence",
    ],
    tech: ["Generative AI", "React", "AWS", "Service design"],
    period: "4 weeks",
  },
  {
    title: "Gamstop National Self-Exclusion Platform",
    role: "Principal Engineer",
    description:
      "Transformed the UK's national gambling self-exclusion service into a platform connecting every gambling operator in the country.",
    achievements: [
      "Architectural improvements to a system handling 300+ million daily transactions",
      "Consolidated 8 siloed platforms into one unified, high-availability portal",
      "Zero-downtime operation, disaster recovery proven under load and stress testing",
    ],
    tech: ["TypeScript", "React", "Next.js", "AWS", "Node.js", "Java"],
    live: "https://www.gamstop.co.uk",
    period: "2024",
  },
  {
    title: "Target Group Mortgage Hub",
    role: "Technical Lead",
    description:
      "An innovative mortgage origination platform: a suite of microservices with three user portals that transformed mortgage processing for major UK lenders.",
    achievements: [
      "20+ microservices on Kubernetes with event-driven architecture",
      "Three user portals (broker, lender, admin) in React/TypeScript",
      "Real-time status tracking and third-party credit/valuation integrations",
    ],
    tech: ["React", "TypeScript", "Hasura", "Apache Kafka", "GraphQL", "PostgreSQL", "Java", "Kubernetes"],
    live: "https://www.targetgroup.com/our-capabilities/mortgage-hub/",
    period: "2022",
  },
  {
    title: "Scottish Widows Pensions Platform",
    role: "Technical Lead, Lloyds Banking Group",
    description:
      "Led an 11-person team building a mission-critical, event-driven pensions platform handling billions in transactions.",
    achievements: [
      "Lifted team velocity 40% through process improvements",
      "Cut deployment time from days to hours",
    ],
    tech: ["React", "Node.js", "Kafka", "GraphQL", "Kubernetes", "Java"],
    period: "2021 – 2022",
  },
  {
    title: "Co-op Shifts",
    role: "Senior Software Engineer, Service Designer, User Researcher",
    description:
      "A workforce-management platform used by over 50,000 Co-op food-store colleagues nationwide.",
    achievements: [
      "Scaled to 50,000+ active users",
      "Won Best Mobile Application at the Big Chip Awards 2018",
    ],
    tech: ["Python", "React", "AWS", "gRPC"],
    live: "https://shifts.coop.co.uk",
    image: shiftsImage,
    period: "2016 – 2018",
  },
  {
    title: "Co-op Digital Innovation",
    role: "Senior Software Engineer, Service Designer",
    description:
      "Multiple projects improving Co-op's digital presence and operational efficiency.",
    achievements: [
      "Real-time store dashboard reducing paper-based tasks",
      "Product finder turning a 20-minute process into seconds",
      "Digital service manual for consistent development practices",
    ],
    tech: ["Ruby on Rails", "React", "Go", "Real-time APIs"],
    images: {
      dashboard: dashboardImage,
      productFinder: productFinderImage,
      serviceManual: serviceManualImage,
      membership: membershipImage,
    },
    period: "2016 – 2018",
  },
  {
    title: "local.co.uk Marketplace",
    role: "Technical Lead, Service Designer",
    description:
      "A complete ecommerce platform for local artisans to sell handmade and bespoke products, delivered in 14 weeks.",
    achievements: [
      "Full marketplace platform with seller interface and API",
      "Comprehensive seller onboarding experience",
    ],
    tech: ["Python", "React", "AWS"],
    image: localImage,
    period: "2018",
  },
  {
    title: "Footasylum",
    role: "Technical Architect",
    description:
      "Lead architect across a distributed team delivering a re-platformed checkout carrying £90m annual revenue.",
    achievements: [
      "Introduced production-readiness processes across the estate",
      "Drove culture change in the development community",
    ],
    tech: ["Architecture", "E-commerce"],
    period: "2019",
  },
  {
    title: "MPP Global",
    role: "Software Engineer",
    description: "A 20m+ line CRM codebase for a global subscription-billing platform, in a team of 5.",
    achievements: [
      "Critical i18n retrofit unlocking a multi-million-pound deal",
      "Custom cryptographic scheme cutting storage in the offers/voucher system",
      "High-availability platform stood up in a new AWS region for USA and Japan",
    ],
    tech: ["Node.js", "C#", "ASP.NET", "T-SQL", "AWS"],
    live: "https://www.mppglobal.com/",
    period: "2015 – 2016",
  },
];

export const workGroups = [
  {
    id: "ai-data",
    label: "AI & Data",
    title: "AI & data showcases",
    intro:
      "Where data and systems thinking become something you can actually see: a national curriculum rendered as one navigable map, and an open-data study that turns an ambulance queue into a tested, falsifiable model.",
    items: aiShowcases,
    image: lcrSummitCover,
  },
  {
    id: "founder-ventures",
    label: "Founder Ventures",
    title: "Founder ventures & products",
    intro:
      "Solo founder and technology lead across live ventures spanning generative-AI systems, applied AI in a regulated clinical domain, and full-stack e-commerce and consumer brands. I own every layer: AI/ML, architecture, product, design, and go-to-market.",
    items: ventureProjects,
    image: sabrinaHero,
  },
  {
    id: "client-delivery",
    label: "Client Delivery",
    title: "Client & consultancy delivery",
    intro:
      "A decade delivering for the BBC, NHS Digital, major UK retailers, and financial services, leading teams and architecture from discovery through to production at national scale.",
    items: clientProjects,
    image: shiftsImage,
  },
];
